import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500">精选优质影视专题，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-colors duration-200 hover:bg-background-50/80 cursor-pointer"
            >
              <div className="relative w-full h-[220px] md:h-[260px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="text-xs text-primary-600 font-medium mb-1.5">{item.category}</div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {carouselItems.slice(3, 5).map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group flex flex-col sm:flex-row bg-background-50 rounded-lg overflow-hidden transition-colors duration-200 hover:bg-background-50/80 cursor-pointer"
            >
              <div className="relative w-full sm:w-[280px] h-[180px] flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-center">
                <div className="text-xs text-primary-600 font-medium mb-1.5">{item.category}</div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}